import { render, staticRenderFns } from "./bindUserInfo.vue?vue&type=template&id=137a0e8c&scoped=true&"
import script from "./bindUserInfo.vue?vue&type=script&lang=js&"
export * from "./bindUserInfo.vue?vue&type=script&lang=js&"
import style0 from "./bindUserInfo.vue?vue&type=style&index=0&id=137a0e8c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "137a0e8c",
  null
  
)

export default component.exports